export const isBrowser = (
  browser: 'chrome' | 'ie' | 'firefox' | 'safari' | 'opera'
) => {
  const userAgentString = navigator.userAgent.toLowerCase()

  const chromeAgent = userAgentString.indexOf('chrome') > -1
  const ieAgent =
    userAgentString.indexOf('msie') > -1 || userAgentString.indexOf('rv:') > -1

  const firefoxAgent = userAgentString.indexOf('firefox') > -1
  const safariAgent = userAgentString.indexOf('safari') > -1
  const operaAgent = userAgentString.indexOf('op') > -1

  switch (browser) {
    case 'chrome':
      return chromeAgent
    case 'ie':
      return ieAgent
    case 'firefox':
      return firefoxAgent
    case 'safari':
      // Discard Safari since it also matches Chrome
      return !chromeAgent && safariAgent
    case 'opera':
      // Discard Chrome since it also matches Opera
      return !chromeAgent && operaAgent
    default:
      return false
  }
}

export const removeTrailingSlash = (str: string) =>
  str.endsWith('/') ? str.slice(0, -1) : str
